import React from 'react';
import { Field, Form, Formik } from 'formik';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { enviaFormRequest } from '@store/user/actions';
import { Button, Toggler, Tooltip } from '@components';

import { BPDInitialValues, BPDSchema } from '@schemas';

const Label = () => {
  return (
    <>
      <p>
        Declaro estar ciente que:
        <Tooltip title="Instituto que faculta o participante a permanecer com o plano previdenciário sendo o saldo da conta corrigido mensalmente pela rentabilidade do perfil escolhido. Exercendo esta opção o participante fazer aportes (contrições eventuais) para a conta de aposentadoria e alterar o perfil de investimento de acordo com as regras vigentes. Durante o período de diferimento (prazo transcorrido entre o desligamento e a concessão do benefício ou a opção pelo Resgate/Portabilidade) será debitada mensalmente na conta de aposentadoria a taxa administrativa. Quando elegível terá seu benefício concedido com base no saldo da conta de aposentadoria acumulado no momento da concessão e as regras regulamentares vigentes na data da concessão. Caso, dentro do prazo estipulado, o Participante não se manifeste por qualquer dos Institutos, será presumida a opção pelo BPD. A opção pelo BPD, manifestada ou presumida, permite posterior opção pelo Autopatrocínio, Portabilidade ou Resgate.">
          ?
        </Tooltip>
      </p>
      <ol>
        <li>
          A opção pelo BPD, manifestada ou presumida, permite posterior opção
          pelo Autopatrocínio, Portabilidade ou Resgate.
        </li>
        <li>
          A cobertura de invalidez e morte será mediante conversão do saldo
          atualizado da Conta de Aposentadoria em renda mensal.
        </li>
        <li>
          O benefício de RMP ou RPI será calculado com base no saldo atualizado
          da Conta de Aposentadoria, na data da concessão.
        </li>
        <li>
          O custeio administrativo fixado no plano de custeio será de
          integralmente de minha responsabilidade.
        </li>
      </ol>
    </>
  );
};

export const BPDTaesa = ({ title, reference }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <div className="card">
      <div className="card-body">
        <h3 className="fw-bold ts-20 mb-32">{title}</h3>
        <p className="mb-3">
          Considerando o disposto no Regulamento do Plano Taesa de Benefícios
          Previdenciários (Plano Taesaprev), venho, por meio deste, formalizar
          minha opção pelo Benefício Proporcional Diferido.
        </p>
        <Formik
          validateOnMount
          initialValues={BPDInitialValues}
          validationSchema={BPDSchema}
          onSubmit={(values) => {
            dispatch(
              enviaFormRequest({
                campos: values,
                formulario: reference,
                navigate,
              })
            );
          }}
        >
          {({ handleSubmit, isValid }) => {
            return (
              <Form>
                <div className="row">
                  <Field
                    name="declaracao"
                    component={Toggler}
                    label={<Label />}
                  />
                </div>
                <hr className="mt-32 mt-xs-0 mb-32" />
                <div className="row">
                  <div className="col-12 col-md-6 col-xl-4 ms-0 ms-md-auto">
                    <div className="d-block d-md-flex align-items-center">
                      <Button
                        disabled={!isValid}
                        className="ms-0 ms-md-3"
                        onClick={handleSubmit}
                      >
                        Continuar
                      </Button>
                    </div>
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};
